// tslint:disable:trailing-comma
export var spaRoutes = [
    {
        name: 'Profile',
        path: '/profile',
        component: function () {
            return import(/* webpackChunkName: "profile" */ '@/pages/profile/Index.vue');
        },
        meta: {
            authorize: 'PROFILE_INFO',
        },
    },
    {
        name: 'Opportunity Loads',
        path: "/opportunity/loads",
        component: function () { return import(
        /* webpackChunkName: "opportunity-loads" */
        '@/pages/opportunity-management/opportunity-loads/Index.vue'); },
        meta: {
            includeInMenu: true,
            authorize: 'OPPORTUNITYLOADS',
        },
    },
    {
        name: 'Opportunity Actions',
        path: "/opportunity/actions",
        component: function () { return import(
        /* webpackChunkName: "opportunity-actions" */
        '@/pages/opportunity-management/opportunity-actions/Index.vue'); },
        meta: {
            includeInMenu: true,
            authorize: 'OPPORTUNITYACTIONS',
        },
    },
    {
        name: 'Contract Tracking',
        path: '/contract/tracking',
        component: function () { return import('@/pages/contract-management/contract-tracking/Index.vue'); },
        meta: {
            includeInMenu: true,
            new: true,
            authorize: 'CONTRACTTRACKING',
        },
    },
];
